jQuery(document).ready(function($) {
	
	var nav = $('header nav');
	var formSearch = $('header #form-search');
	var buttonSearch = $('.button-search');

	buttonSearch.on('click', function(e){
		var $this = $(this);
			if ( $this.hasClass('active') || $('div.second').hasClass('show') ) {
				if( formSearch.find('input').val() != '' ){
					formSearch.submit();
				}
			} else {
				$this.toggleClass('active');
				nav.fadeToggle('fast');
				formSearch.fadeToggle('fast');
				formSearch.find('input').focus();		
			}
	});

	$(document).on('click', function(e){
		if (buttonSearch.hasClass('active') && !formSearch.find('input').is(":focus")) {
			buttonSearch.removeClass('active');
			formSearch.fadeOut('fast');
			nav.fadeIn('fast');
		}
	});


	$('.carousel').carousel();

	$('.navicon').click(function(){
		var $this = $(this);
		$this.toggleClass('visible');

		$('header > div.second').toggleClass('show');
	});

	(function(){

		var sevondDiv = $('header > div.second');
		var firstDiv = $('header > div.first');
		var address = $('header > div.first .address');

		$(window).on('resize load', function(){

			if($(window).width() <= 983){
				sevondDiv.css('height', $(window).height());
				address.appendTo(sevondDiv);
			} else {
				if(sevondDiv.has('.address').length){
					address.prependTo(firstDiv);
					sevondDiv.css('height', 'auto')
				}
				sevondDiv.removeClass('show')
				$('.navicon').removeClass('visible')
			}
		})		
	})();


	$('section#product-list .filter span').on('click', function(){
		$('.category-list').fadeIn('fast');
	});

	$('.category-list .close-filter').on('click', function(){
		$('.category-list').fadeOut('fast');
	});

	$('.owl-carousel').owlCarousel({
		loop: false,
		margin: 45,
		nav: false,
		responsive:{
			0:{
			    items: 1,
			    stagePadding: 50,
			},
			600:{
			    items: 4
			},
			1000:{
			    items: 7
			}
		}
	});

	$(".scroll_down_1").click(function() {
	    $('html, body').animate({
	        scrollTop: $("#categories").offset().top - 120
	    }, 2000);
	});


	$('nav > li').on('click', function()
	{

		if($(window).width() < 992)
		{
			var ulElement = $(this).find('ul');

			if(ulElement.hasClass('mobileshow')){
				$(this).find('ul').removeClass( "mobileshow" );
			}else{
				$(this).find('ul').addClass( "mobileshow" );
			}
		}

	});



});